import { isIos, isAndroid } from "../../libs/chief-bridge";

/**
 * 比较版本号，支持 "0.9.14(1)" 格式，只取主版本号部分
 * @returns true 如果 version >= target
 */
function compareVersionGte(version: string, target: string): boolean {
  const cleanVersion = version.replace(/\(.*\)$/, "").trim();
  const vParts = cleanVersion.split(".").map((n) => parseInt(n, 10) || 0);
  const tParts = target.split(".").map((n) => parseInt(n, 10) || 0);

  for (let i = 0; i < Math.max(vParts.length, tParts.length); i++) {
    const v = vParts[i] || 0;
    const t = tParts[i] || 0;
    if (v > t) return true;
    if (v < t) return false;
  }
  return true; // 相等也满足
}

/**
 * 判断当前版本是否支持分享按钮
 * - iOS: >= 0.9.13
 * - Android: >= 0.9.14
 */
export function supportsShare(): boolean {
  const iosVersion = localStorage.getItem("iosVersion") || "";
  const aosVersion = localStorage.getItem("aosVersion") || "";

  if (isIos() && iosVersion) {
    return compareVersionGte(iosVersion, "0.9.13");
  }
  if (isAndroid() && aosVersion) {
    return compareVersionGte(aosVersion, "0.9.14");
  }

  return false;
}
